import React from "react";
import FileUploadImg from "../assets/icons/upload.png";
import {
  GST_FILE_SIZE_MB,
  MAX_FILE_SIZE_MB,
  UPLOAD_TYPE,
  ALLOWED_ONLY_PDF_FILE,
  ALLOWED_PDF_FILE_FORMATS,
  ALLOWED_FILE_FORMATS,
} from "../config/constant";

const Upload = ({ handleFileChange, path, fileType, dynamicSize }) => {
  //const maxSize = fileType=== UPLOAD_TYPE.PDF_IMAGE ? GST_FILE_SIZE_MB : MAX_FILE_SIZE_MB;
  let maxSize = 0;
  function determineMaxSize() {
    if (dynamicSize) {
      maxSize = dynamicSize;
    } else {
      if (fileType === UPLOAD_TYPE.PDF_IMAGE) {
        maxSize = GST_FILE_SIZE_MB;
      } else {
        maxSize = MAX_FILE_SIZE_MB;
      }
    }
  }
  determineMaxSize();

function determinFileType() {
  if (fileType === UPLOAD_TYPE.PDF) {
    return ALLOWED_ONLY_PDF_FILE.join(","); 
  } else if (fileType === UPLOAD_TYPE.PDF_IMAGE) {
    return ALLOWED_PDF_FILE_FORMATS.join(","); 
  } else {
    return ALLOWED_FILE_FORMATS.join(",");
  }
}
  let acceptFileType = determinFileType();

  function FileTypemessage() {
    if (fileType === UPLOAD_TYPE.PDF_IMAGE) {
      return `PDF, PNG, JPG or JPEG (File size: ${maxSize} MB)`;
    } else if (fileType === UPLOAD_TYPE.PDF) {
      return `PDF (File size: ${maxSize} MB)`;
    } else {
      return `PNG, JPG or JPEG (File size: ${maxSize} MB)`;
    }
  }
  let fileTypeMessage = FileTypemessage();

  return (
    <div
      style={{
        //width: "100%",
        // height: "202px",
        border: "1px dashed #384EB74D",
        borderRadius: "4px",
        textAlign: "center",
        padding: 20,
        // cursor: "pointer",
        // marginBottom: "4%",
      }}
    >
      <span>
        <label htmlFor={path} style={{ color: "#483EA8", cursor: "pointer" }}>
          {/* Browse */}
          <input
            id={path}
            type="file"
            style={{ display: "none" }}
            onChange={handleFileChange}
            // multiple
            accept={acceptFileType}
          />

          <div style={{ textAlign: "center" }}>
            <img
              src={FileUploadImg}
              alt=""
              style={{ height: "40px", width: "40px" }}
            />
          </div>
          <div className="textClickUpload">
            Click to upload <span>or drag and drop</span>
          </div>

          <div className="textJgp">
              <span>{fileTypeMessage}</span>           
          </div>
        </label>
      </span>
    </div>
  );
};

export default Upload;
